/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Tab, Tabs } from "@nordcloud/gnui";
import { Events } from "~/components/Events";
import { useTabsWithUrl } from "~/hooks";
import { Environments } from "./Environments";

type Props = {
  nid: string;
};

export function ApplicationDetailsTabs({ nid }: Props) {
  const { activeTab, setActiveTab } = useTabsWithUrl();

  return (
    <Tabs step={activeTab} handleTab={setActiveTab}>
      <Tab heading="Environments" caption="List of environments">
        <Environments />
      </Tab>
      <Tab heading="Events" caption="Change management">
        <Events nid={nid} />
      </Tab>
    </Tabs>
  );
}
